import Person, { names as personNames } from '@/common/interfaces/dto/Person';
import Address, { names as addressNames } from '@/common/interfaces/dto/Address';
import Phone, { names as phoneNames } from '@/common/interfaces/dto/Phone';

export interface ContestEntry {
  Person: Person;
  Phone: Phone;
  Address: Address;
  Barcode: number;
  Agency: String;
  Tag: String;
}

const formNames = {
  Person: 'Person',
  Address: 'Address',
  Phone: 'Phone',
  Barcode: 'Barcode',
  Agency: 'Agency',
  Tag: 'Tag'
};

export const names = {
  ...personNames,
  ...addressNames,
  ...phoneNames,
  ...formNames,
};
